import Modal, {ModalProps} from 'react-bootstrap/Modal';
import React, {useEffect, useState} from "react";
import axios from "axios";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";
import {useTranslation} from "react-i18next";
import {toast} from "react-custom-alert";

const RemoveConfirmation = ({ customID, customToken, elementType, ...props }: ModalProps)  => {
    const { t } = useTranslation();
    const{getAppUniqueToken} = useAppUniqueToken();
    const [uaToken, setUaToken] = useState(getAppUniqueToken);

    const handleConfirm = () => {

        const payload = {
            customID,
            uaToken
        };

        axios.post('/api/remove-' + elementType, payload)
            .then(() => {
            //alert("REMOVE success");
                location.reload();
        }).catch(error => {
            console.log(error);
            toast.error(t('messages.defaultErrorMessage'));
        });
    };


    useEffect(() => {
        if(customToken)
            setUaToken(customToken);
    }, [customToken])

    return (

        <Modal
            {...props}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body style={{height:'200px'}}>
                <h4>{t('captions.warning')}</h4> <br />
                Sei sicuro di voler cancellere questa adesione dal tuo elenco?<br />
                L'operazione non è reversibile!
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn_1 green" onClick={handleConfirm}>{t('captions.confirm')}</button>
                <button type="button" className="btn_1 yellow" onClick={props.onHide}>{t('captions.cancel')}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default RemoveConfirmation;
